<template>
  <div class="text-center" style="margin-top: 5px">
    <b-alert show>{{ message || 'Nenhum item nessa lista' }} </b-alert>
  </div>
</template>


<script>
export default {
  name: 'empty-list',
  data: function () {
    return {};
  },
  computed: {},
  beforeMount: function () {},
  methods: {},
  components: {},
  props: ['message'],
};
</script>